<template>
  <div class="switch">
    <span class="switch-label" :class="{'active': checkValue(1)}"
          @click="setValue(1)">{{ val1 }}</span>
    <span class="switch-label" :class="{'active': checkValue(2)}"
          @click="setValue(2)">{{ val2 }}</span>
    <span class="switch-selection" :class="{'value-right': checkValue(2)}"></span>
  </div>
</template>

<script>
  export default {
    props: {
      val1: {
        type: String,
        default: '17/18'
      },
      val2: {
        type: String,
        default: '18/19'
      },
      value: {
        default: 1
      }
    },
    methods: {
      setValue (val) {
        this.currValue = val
        this.$emit('changed', val)
      },
      checkValue (val) {
        return this.value * 1 === val
      }
    }
  }

</script>

<style scoped>
  @import "../.././assets/css/variables.css";

  .switch {
    position: relative;
    margin: 0px auto;
    height: 26px;
    display: flex;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 3px;
  }

  .switch-label {
    position: relative;
    z-index: 2;
    flex: 1;
    line-height: 26px;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.45);
    text-align: center;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.45);
    cursor: pointer;
  }

  .switch-label.active {
    font-weight: bold;
    color: white;
    transition: all 0.15s ease-out;
  }

  .switch-selection.value-right {
    transform: translateX(100%);
  }

  .switch-selection {
    display: block;
    position: absolute;
    z-index: 1;
    top: 2px;
    left: 2px;
    width: calc(50% - 2px);
    height: 22px;
    background: var(--blue);
    border-radius: 3px;
    box-shadow: inset 0 1px rgba(255, 255, 255, 0.5), 0 0 2px rgba(0, 0, 0, 0.2);
    transition: all 0.15s ease-out;
  }

</style>



// WEBPACK FOOTER //
// ToggleYear.vue?baab4028